module.exports = __webpack_public_path__ + "img/f066da301af1e9c5a96de8586466d5fb.png";